import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Http, HttpModule, Jsonp, JsonpModule } from '@angular/http';
import 'rxjs/add/operator/toPromise';

var DeezerApiService = (function () {
    /**
     * @param {?} http
     * @param {?} _jsonp
     */
    function DeezerApiService(http, _jsonp) {
        this.http = http;
        this._jsonp = _jsonp;
        this.searchUrl = 'https://api.deezer.com/search?output=jsonp&callback=JSONP_CALLBACK&q=';
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DeezerApiService.prototype.search = function (value) {
        var /** @type {?} */ url = this.searchUrl + value;
        return this._jsonp.get(url)
            .toPromise()
            .then(function (response) {
            return response.json();
        })
            .catch(this.handleError);
    };
    /**
     * @param {?} error
     * @return {?}
     */
    DeezerApiService.prototype.handleError = function (error) {
        return Promise.reject(error.message || error);
    };
    return DeezerApiService;
}());
DeezerApiService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
DeezerApiService.ctorParameters = function () { return [
    { type: Http, },
    { type: Jsonp, },
]; };

var DeezerApiModule = (function () {
    function DeezerApiModule() {
    }
    /**
     * @return {?}
     */
    DeezerApiModule.forRoot = function () {
        return {
            ngModule: DeezerApiModule,
            providers: [DeezerApiService]
        };
    };
    return DeezerApiModule;
}());
DeezerApiModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    HttpModule,
                    JsonpModule
                ],
                declarations: [],
                exports: []
            },] },
];
/**
 * @nocollapse
 */
DeezerApiModule.ctorParameters = function () { return []; };

export { DeezerApiModule, DeezerApiService };



//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/angular-deezer-api/index.js
// module id = ../../../../angular-deezer-api/index.js
// module chunks = 4